module.exports = __webpack_public_path__ + "img/notary_hov_pre_img.351cd2a4.png";